export const STATUS_MESSAGES = {
    // HTTP Status 相關
    401: 'Please log in.',
    403: 'Access denied.',
    404: 'Resource not found.',
    500: 'System error, please try again later.',
    502: 'System maintenance in progress.',
    504: 'Request timeout, please try again later.',
    
    // 業務邏輯相關
    '1001': 'First name is required.',
    '1002': 'Last name is required.',
    '1003': 'Job title is required.',
    '1004': 'Email is required.',
    '1005': 'Email format invalid.',
    '1006': 'Email has been taken.',
    '1007': 'TesterSubscriptionEnd Time format invalid',
    '1011': 'Password is required.',
    '1012': 'Password-confirm is required.',
    '1013': 'Password and password-confirm not match',
    '1014': 'Failed to update password.',
    '1015': 'File is required.',
    '1016': 'File format invalid.',
    '1021': 'Role is required.',
    '1022': 'Role does not exist.',
    '1023': 'Role invalid.',
    '1024': 'Role cannot be changed while the user still has an ongoing non-free subscription.',
    '1031': 'SubscriptionLevel does not exist.',
    '1041': "This account's subscription is still active and cannot be deleted.",
    '1050': 'Failed to create user.',
    'default': 'Something went wrong. Please try again.',
};  